/** Carry only shared Pages filters, never page IDs or unrelated product state. */
export function pagesNavigationHref(
  href: string,
  pathname: string,
  searchParams: { get(key: string): string | null }
): string {
  if (!/^\/app\/pages(?:\/|$)/.test(pathname) || !/^\/app\/pages(?:\/|$)/.test(href)) return href;
  const [target, query = ''] = href.split('?');
  const params = new URLSearchParams(query);
  for (const key of ['projectId', 'range', 'path']) {
    const value = searchParams.get(key);
    if (value && !params.has(key)) params.set(key, value);
  }
  if (params.get('range') === 'custom') {
    for (const key of ['start', 'end']) {
      const value = searchParams.get(key);
      if (value && !params.has(key)) params.set(key, value);
    }
  }
  const crawl = searchParams.get('crawl') || searchParams.get('crawlId');
  if (crawl && (target === '/app/pages' || target === '/app/pages/review')) {
    const key = target === '/app/pages' ? 'crawl' : 'crawlId';
    if (!params.has(key)) params.set(key, crawl);
  }
  return params.size ? `${target}?${params}` : href;
}
